<app-page-heading [title]="formTitle" [subheadingIcon]="'fa fa-user-plus'"></app-page-heading>

<app-user-form #userForm [user]="user" [mode]="mode" [userTypeLabelKey]="'user-dashboard.groups.chep-manager'"
               [create]="onCreate" [update]="onUpdate" [showRegions]="true" [regions]="regions"
               [remove]="onDelete" [block]="onToggleBlocking"
               [unblockIp]="onUnblockIp"
               [canActivateBluechat]="true"
               (enableBluechat)="enableBluechat($event)"
               (changePassword)="changePassword($event)"
               (afterCreate)="goToChepManagerList()"
               (afterDelete)="goToChepManagerList()"
>
</app-user-form>
